import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import ToasterContext from "context/ToastContext";
import App from "App";
import { Provider } from "react-redux";
import { store } from "lib/store";

// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "context";

const container = document.getElementById("app");
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <MaterialUIControllerProvider>
        <ToasterContext />
        <App />
      </MaterialUIControllerProvider>
    </BrowserRouter>
  </Provider>
);
